<mat-form-field class="example-full-width" appearance="outline">
  <mat-label>Производитель</mat-label>
  <input matInput [formControl]="control" [matAutocomplete]="auto" placeholder="Производитель"
    (focus)="optionsActivated = true" />
  <mat-autocomplete
    #auto="matAutocomplete"
    [displayWith]="displayProperty"
    (optionSelected)="handleSelect($event)"
  >
    <ng-container *ngIf="!loadOnFocus || optionsActivated">
      <ng-container *ngIf="filteredOptions | async as brands">
        <mat-option *ngFor="let brand of brands" [value]="brand">
          {{ brand.description }}
        </mat-option>
        <mat-option *ngIf="brands.length === 0" [value]="control.value">
          Создать {{ control.value }}
        </mat-option>
      </ng-container>
    </ng-container>
  </mat-autocomplete>
</mat-form-field>
